import { apiClient as api } from "./httpClient";

export interface AiFeatureStatus {
  enabled: boolean;
  termsAccepted: boolean;
  currentTermsVersion: string;
  termsTitle: string;
  termsBody: string;
  // Já no relógio da entidade — exibir com o formatDateTime literal do sistema.
  acceptedAt?: string;
  acceptedByName?: string;
  acceptedVersion?: string;
}

// Feature de Assistentes de IA (M0): status/aceite do termo pela entidade. Só o admin da
// entidade acessa (o backend valida via EntityOwnershipGuard).
export const aiFeatureService = {
  getStatus: async (entityId: string): Promise<AiFeatureStatus> => {
    const response = await api.get(`/ai-feature/status/${entityId}`);
    return response.data;
  },
  acceptTerms: async (entityId: string): Promise<void> => {
    await api.post("/ai-feature/accept-terms", { entityId });
  },
};
